import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import LoaderComponent from '@components/LoaderComponent';
import PieChart from '@components/PieChart';
import { toastError } from '@components/Toast';
import CommonImage from '@components/CommonImage';

import { generateOrderDashboardParams } from '@features/filter/static/filterUtil';

import ApiClient from '@lib/apiClient';

import { convertNumberToUSFormat, getNumberUnit } from '@utils/Util';

const OrderSummary = () => {
	const [orderSummary, setOrderSummary] = useState({});
	const [loader, setLoader] = useState(false);
	const [isShowFullValue, setIsShowFullValue] = useState(false);
	const filterFields = useSelector((store) => store.filterFieldStore);

	const fetchOrderSummary = () => {
		setLoader(true);
		let params = generateOrderDashboardParams(filterFields);
		ApiClient.GET('getOrderDashboardSummary', `?${params.slice(1)}`)
			.then((response) => {
				setOrderSummary(response.data);
				setLoader(false);
			})
			.catch((error) => {
				setLoader(false);
				toastError(error.response.data.message);
			});
	};

	useEffect(() => {
		fetchOrderSummary();
	}, [filterFields]);

	const getPercentageValue = (n1 = 0, n2 = 0) => {
		return (n1 / (n1 + n2)) * 100;
	};

	// const getMarginPercent = () => {
	// 	return (orderSummary.margin / orderSummary.poAmount) * 100;
	// };

	const generateChartData = () => {
		const nitexCount = getPercentageValue(orderSummary.nitexDesignCount, orderSummary.buyerDesignCount);
		const buyerCount = getPercentageValue(orderSummary.buyerDesignCount, orderSummary.nitexDesignCount);
		return {
			labels: ['Nitex Design', 'Buyer Design'],
			datasets: [
				{
					label: '',
					data: [nitexCount, buyerCount],
					backgroundColor: ['rgba(59, 130, 246, 1)', 'rgba(171, 213, 117, 1)'],
					borderWidth: 0
				}
			]
		};
	};

	const renderToggleBtn = () => {
		return (
			<span className="cursor-pointer" onClick={() => setIsShowFullValue(!isShowFullValue)}>
				{isShowFullValue ? (
					<CommonImage src="/icons/Left-arrow.svg" alt="toggle" width={16} height={16} />
				) : (
					<CommonImage src="/icons/right-arrow.svg" alt="toggle" width={16} height={16} />
				)}
			</span>
		);
	};

	return (
		<LoaderComponent loading={loader}>
			<div className="orders-summary">
				<div className="single-summary">
					<p className="regular-12 gray_dark_02">PO Qty</p>
					<p className="regular-12 gray_dark_01">
						{orderSummary?.poQuantity > 0
							? convertNumberToUSFormat(orderSummary?.poQuantity, true)
							: 0}
					</p>
				</div>
				<div className="single-summary">
					<p className="regular-12 gray_dark_02">PO value</p>
					<p className="regular-12 gray_dark_01 d-flex align-items-center">
						{orderSummary?.poAmount > 0
							? `$${isShowFullValue ? convertNumberToUSFormat(orderSummary?.poAmount) : getNumberUnit(orderSummary?.poAmount)}`
							: '0'}
						{renderToggleBtn()}
					</p>
				</div>
				<div className="single-summary">
					<p className="regular-12 gray_dark_02">SC value</p>
					<p className="regular-12 gray_dark_01 d-flex align-items-center">
						{orderSummary?.productionCost > 0
							? `$${isShowFullValue ? convertNumberToUSFormat(orderSummary?.productionCost) : getNumberUnit(orderSummary?.productionCost)}`
							: '0'}
						{renderToggleBtn()}
					</p>
				</div>
				<div className="single-summary">
					<p className="regular-12 gray_dark_02">Expected margin</p>
					<p className="regular-12 gray_dark_01">
						{orderSummary?.margin > 0
							? `$${isShowFullValue ? convertNumberToUSFormat(orderSummary?.margin) : getNumberUnit(orderSummary?.margin)}`
							: '0'}
						{orderSummary?.marginPercent > 0
							? ` (${orderSummary?.marginPercent.toFixed(2)}%)`
							: '0'}
						{renderToggleBtn()}
					</p>
				</div>
				<div className="single-summary">
					<p className="regular-12 gray_dark_02">Shipment Qty</p>
					<p className="regular-12 gray_dark_01">
						{orderSummary?.shipmentQuantity > 0
							? `${convertNumberToUSFormat(orderSummary?.shipmentQuantity, true)}`
							: '0'}
					</p>
				</div>
				<div className="single-summary">
					<p className="regular-12 gray_dark_02">Shipment value</p>
					<p className="regular-12 gray_dark_01 d-flex align-items-center">
						{orderSummary?.shipmentAmount > 0
							? `$${isShowFullValue ? convertNumberToUSFormat(orderSummary?.shipmentAmount) : getNumberUnit(orderSummary?.shipmentAmount)}`
							: '0'}
						{renderToggleBtn()}
					</p>
				</div>
				<div className="single-summary">
					<PieChart data={generateChartData()} />
					<div className="ml-2">
						<p className="regular-12 gray_dark_02">
							<span className="c-indicator nitex" />
							Nitex design
							<span className="semibold-12 ml-1">
								{orderSummary?.nitexDesignCount > 0
									? `${convertNumberToUSFormat(orderSummary?.nitexDesignCount, true)}`
									: 0}
								{orderSummary.nitexDesignCount > 0
									? `(${getPercentageValue(
											orderSummary.nitexDesignCount,
											orderSummary.buyerDesignCount
										).toFixed(2)}%)`
									: '(0%)'}
							</span>
						</p>
						<p className="regular-12 gray_dark_02">
							<span className="c-indicator buyer" />
							Buyer design
							<span className="semibold-12 ml-1">
								{orderSummary?.buyerDesignCount > 0
									? `${convertNumberToUSFormat(orderSummary?.buyerDesignCount, true)} `
									: '0'}
								{orderSummary?.buyerDesignCount > 0
									? `(${getPercentageValue(
											orderSummary.buyerDesignCount,
											orderSummary.nitexDesignCount
										).toFixed(2)}%)`
									: '(0%)'}
							</span>
						</p>
					</div>
				</div>
			</div>
		</LoaderComponent>
	);
};
export default OrderSummary;
